import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24702142"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-docs" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "center profile-docs__doc-img" }

import { FileType } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentList',
  props: {
    documents: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
      return (_openBlock(), _createElementBlock("a", {
        href: document.path,
        class: "profile-docs__doc",
        download: "",
        target: "_blank"
      }, [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_base_image, {
            src: require('@/assets/img/common/icon-pdf.png'),
            contain: "",
            height: "30",
            name: "doc"
          }, null, 8, ["src"])
        ]),
        _createElementVNode("span", null, _toDisplayString(document.name), 1)
      ], 8, _hoisted_2))
    }), 256))
  ]))
}
}

})